/**
 * Runtime configuration for the headless core.
 *
 * A site hands over its public values once, at start-up; nothing in this package reads
 * `process.env` or `import.meta.env` of its own, so the same build works in a browser, in
 * a test and in a build script. Only public values belong here — a secret would be shipped
 * to every visitor.
 */
/**
 * TEnergy's WalletConnect project (owner, dashboard.walletconnect.com, 2026-10-02). Public by design: the
 * relay sees it in every pairing. The dashboard's domain allowlist (tenergy.me, www, admin, admin-nile,
 * tenergyzen.elmeno.dev) is what stops other sites from using it.
 */
export const TENERGY_WALLETCONNECT_PROJECT_ID = "247203ce7230f63121308758ac6d9358";
const defaults = {
    apiBaseUrl: "https://api.tenergy.me/v1",
    mainnetApiBaseUrl: "https://api.tenergy.me/v1",
    tronNetwork: "mainnet",
    tronFullHost: null,
    walletConnectProjectId: null,
};
let current = { ...defaults };
/** Merges the values a site knows; anything omitted keeps its default. */
export function configureWebCore(patch) {
    current = { ...current, ...patch };
}
export function webCoreConfig() {
    return current;
}
/** Test seam: back to the defaults. */
export function resetWebCoreConfig() {
    current = { ...defaults };
}
//# sourceMappingURL=config.js.map